import { render, staticRenderFns } from "./Signatures.vue?vue&type=template&id=0f3d5a08&scoped=true"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"
import style0 from "./Signatures.vue?vue&type=style&index=0&id=0f3d5a08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3d5a08",
  null
  
)

export default component.exports